var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBellCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43896 15.8251C6.5794 16.0683 6.78138 16.2703 7.0246 16.4107C7.26783 16.5511 7.54373 16.625 7.82457 16.625C8.10542 16.625 8.38132 16.5511 8.62454 16.4107C8.86776 16.2703 9.06974 16.0683 9.21018 15.8251",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.834017 11.2858C0.729508 11.4004 0.660539 11.5428 0.6355 11.6959C0.610461 11.8489 0.630431 12.0059 0.692981 12.1478C0.755531 12.2897 0.857965 12.4103 0.987822 12.495C1.11768 12.5798 1.26936 12.6249 1.42442 12.6251H14.2245C14.3795 12.6251 14.5312 12.5801 14.6612 12.4955C14.7911 12.411 14.8937 12.2905 14.9564 12.1487C15.0191 12.0069 15.0393 11.8499 15.0144 11.6969C14.9896 11.5438 14.9208 11.4013 14.8165 11.2866C13.7525 10.1898 12.6245 9.02424 12.6245 5.42502C12.6245 4.15198 12.1188 2.93107 11.2186 2.03089C10.3184 1.13072 9.09749 0.625 7.82445 0.625C6.5514 0.625 5.3305 1.13072 4.43032 2.03089C3.53014 2.93107 3.02443 4.15198 3.02443 5.42502C3.02443 9.02424 1.89562 10.1898 0.834017 11.2858Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellCustom);
export default __webpack_public_path__ + "static/media/notification-bell-custom.62b12f7599706f59a170f44969c24c8d.svg";
export { ForwardRef as ReactComponent };